import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

import { socket } from "./../socket";

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const [isConnected, setIsConnected] = useState(
    socket.connected
  );

  const [socketId, setSocketId] = useState(
    socket.id || null
  );

  const [connectionError, setConnectionError] =
    useState(null);

  useEffect(() => {
    function handleConnect() {

      setIsConnected(true);
      setSocketId(socket.id);
      setConnectionError(null);
    }

    function handleConnectionReady(data) {

      setSocketId(data?.socket_id || socket.id || null);
    }

    function handleDisconnect(reason) {

      setIsConnected(false);
      setSocketId(null);
    }

    function handleConnectError(error) {
      console.error("Socket connection error:", error);

      setIsConnected(false);

      setConnectionError(
        error?.message ||
          "ارتباط با سرویس دریافت وضعیت برقرار نشد."
      );
    }

    socket.on("connect", handleConnect);
    socket.on("connection_ready", handleConnectionReady);
    socket.on("disconnect", handleDisconnect);
    socket.on("connect_error", handleConnectError);

    if (!socket.connected) {
      socket.connect();
    }

    return () => {
      socket.off("connect", handleConnect);
      socket.off(
        "connection_ready",
        handleConnectionReady
      );
      socket.off("disconnect", handleDisconnect);
      socket.off(
        "connect_error",
        handleConnectError
      );

      /*
       * Do not call socket.disconnect() here.
       *
       * This socket is shared across the application, and
       * React Strict Mode can run setup/cleanup twice during
       * development.
       */
    };
  }, []);

  const contextValue = useMemo(
    () => ({
      socket,
      socketId,
      isConnected,
      connectionError,

      reconnect() {
        if (!socket.connected) {
          socket.connect();
        }
      },
    }),
    [socketId, isConnected, connectionError]
  );

  return (
    <SocketContext.Provider value={contextValue}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  const context = useContext(SocketContext);

  if (!context) {
    throw new Error(
      "useSocket must be used inside SocketProvider"
    );
  }

  return context;
}